export default __webpack_public_path__ + "static/media/upload.dfeb407b.svg";